import { render, staticRenderFns } from "./business_card.vue?vue&type=template&id=1702e3b1&scoped=true&"
import script from "./business_card.vue?vue&type=script&lang=js&"
export * from "./business_card.vue?vue&type=script&lang=js&"
import style0 from "./business_card.vue?vue&type=style&index=0&id=1702e3b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1702e3b1",
  null
  
)

export default component.exports